import { render } from "./CourseMaterialsPanel.vue?vue&type=template&id=1069da88&scoped=true"
import script from "./CourseMaterialsPanel.vue?vue&type=script&lang=js"
export * from "./CourseMaterialsPanel.vue?vue&type=script&lang=js"

import "./CourseMaterialsPanel.vue?vue&type=style&index=0&id=1069da88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1069da88"]])

export default __exports__